import { useCallback, useEffect } from "react";

export const useMapActions = ({
  setActiveFloor,
  setAction,
  droneNest,
}) => {
  const showOnMap = useCallback(
    (e, drone_nest) => {
      e.preventDefault();
      setActiveFloor(drone_nest.floor);
      setAction((prev) => ({ ...prev, showOnMap: drone_nest.id }));
    },
    [setActiveFloor, setAction],
  );

  useEffect(() => {
    if (droneNest) {
      setAction((prev) => ({ ...prev, showOnMap: droneNest }));
    }
  }, [droneNest]);

  useEffect(() => {
    return () => {
      setAction((prev) => ({ ...prev, showOnMap: null }));
    };
  }, []);

  return { showOnMap };
};